let api = '/tnc/api';
let port = '';
if (process.env.NODE_ENV === 'development') {
  port = ':8080'
}

export const ROUTES = {
  CHECK_IN_OLD: '/check-in/:oagCode',
  CHECK_IN: '/:oagCode',
  DRIVER_PORTAL: '/driver-portal',
  DRIVER_PORTAL_RENTAL_INFO: '/driver-portal/rental-info',
}

export const API = {
  DRIVER_PORTAL_GET_RENTAL_INFO: (endpoint,rentalAgreementNumber, lastName) => `${endpoint}${port}${api}/driver-portal/rental-info?rentalAgreementNumber=${rentalAgreementNumber}&lastName=${lastName}`,
  DRIVER_PORTAL_INCREMENT_COUNTER: (endpoint, counterName, amount) => `${endpoint}${port}${api}/driver-portal/increment-counter?counterName=${counterName}&amount=${amount}`,
  DRIVER_CHECK_IN: (endpoint, oagCode) => `${endpoint}${port}${api}/guest/check-in/${oagCode}`
}
